export default __webpack_public_path__ + "static/m-main-p-sec-bg-01-51460ca004709c2b18902d0358b7d28c.jpg";